import { type InsightsSearchConversionEvent } from 'search-insights/dist/conversion';
import { call, select, takeLatest } from 'typed-redux-saga';

import { IS_B2B } from '@/core/settings/constants';
import { getOrCreateVisitorId } from '@/core/tracking/utils/visitorId';
import { authSelector } from '@/customerManagement/customerManagement.selectors';
import { AlgoliaSearchInsights } from '@/productDiscovery/algolia/searchInsights/AlgoliaSearchInsights';
import {
  ADD_TO_CART_SUCCESS,
  type AddToCartSuccessAction,
} from '@/shoppingCart/AddToCart/AddToCart.actions';

export const buildAlgoliaCvrTrackingData = (
  objectIDs: string[],
  queryID: string,
  index: string,
  userToken: string,
): InsightsSearchConversionEvent => ({
  userToken,
  index,
  eventName: 'Product Added To Cart',
  queryID,
  objectIDs,
});

export function* trackAlgoliaAddToCartProductAdditions(
  action: AddToCartSuccessAction,
) {
  /*TODO: this was a call to 'areFeatureFlagsEnabledSaga' replaced with the value of the flag/abtest. Consider removing this call when you modify the file.*/
  const [isAlgoliaSearchInsightsTrackingEnabled, isB2CEnabled] = [true, true];
  if (
    (IS_B2B && isAlgoliaSearchInsightsTrackingEnabled) ||
    (!IS_B2B && isB2CEnabled)
  ) {
    const cvrQueryData = AlgoliaSearchInsights.getCvrQueryData();

    const { userId } = yield* select(authSelector);
    const visitorId = yield* call(getOrCreateVisitorId);
    const userToken = userId
      ? yield* call(AlgoliaSearchInsights.calculateUserIdHash, String(userId))
      : visitorId;

    const { products, savedProductIds } = action.payload;

    const addedProducts = products.filter((product) =>
      savedProductIds.includes(product.id),
    );

    if (cvrQueryData && userToken && addedProducts.length > 0) {
      const productIds = products.map((product) => String(product.id));
      const trackingData = buildAlgoliaCvrTrackingData(
        productIds,
        cvrQueryData.queryID,
        cvrQueryData.index,
        userToken,
      );
      AlgoliaSearchInsights.send('cvr', trackingData);
      AlgoliaSearchInsights.clearCvrQueryData();
    }
  }
}

export function* watchAddToCartAlgoliaTrackingSaga() {
  yield* takeLatest(ADD_TO_CART_SUCCESS, trackAlgoliaAddToCartProductAdditions);
}
